// Configuration SEO et données structurées (JSON-LD)

export const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  name: 'La Pizza du Lac',
  description: 'Pizzeria artisanale avec burgers et cuisine italienne authentique',
  url: 'https://lapizzadulac.com',
  logo: 'https://lapizzadulac.com/logo.png',
  image: 'https://lapizzadulac.com/photo-burger.jpg',
  address: {
    '@type': 'PostalAddress',
    streetAddress: '48 rue du Fort Saint-Georges',
    addressLocality: 'Géraudot',
    postalCode: '10220',
    addressCountry: 'FR'
  },
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'Customer Service',
    telephone: '+33325803731',
    areaServed: 'FR',
    availableLanguage: ['fr', 'en']
  },
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      opens: '12:00',
      closes: '14:00'
    },
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      opens: '19:00',
      closes: '21:00'
    }
  ],
  sameAs: [
    'https://www.facebook.com/profile.php?id=100063190451556',
    'https://www.instagram.com/la_pizza_du_lac/'
  ],
  priceRange: '$$'
}

export const restaurantSchema = {
  '@context': 'https://schema.org',
  '@type': 'Restaurant',
  name: 'La Pizza du Lac',
  image: [
    'https://lapizzadulac.com/Pizza.jpg',
    'https://lapizzadulac.com/Burger.jpg',
    'https://lapizzadulac.com/photo-burger.jpg'
  ],
  description: 'Restaurant pizzeria avec spécialités burgers et cuisine italienne',
  address: {
    '@type': 'PostalAddress',
    streetAddress: '48 rue du Fort Saint-Georges',
    addressLocality: 'Géraudot',
    postalCode: '10220',
    addressCountry: 'FR'
  },
  telephone: '+33325803731',
  url: 'https://lapizzadulac.com',
  priceRange: '$$',
  servesCuisine: ['Italian', 'Burgers', 'French'],
  sameAs: [
    'https://www.facebook.com/profile.php?id=100063190451556',
    'https://www.instagram.com/la_pizza_du_lac/'
  ]
}

export const breadcrumbSchema = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((item, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name: item.name,
    item: item.url
  }))
})

export function injectSchema(schema) {
  const script = document.createElement('script')
  script.type = 'application/ld+json'
  script.textContent = JSON.stringify(schema)
  document.head.appendChild(script)

  return () => {
    if (script.parentNode) {
      script.parentNode.removeChild(script)
    }
  }
}

